import { IPlannedRouteAudit } from "@tms/_models/IPlannedRouteAudit";

export class PlannedRouteAuditService {

    static $inject = ["$http", "$q"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly $q: angular.IQService,
    ) {
    }

    getPlannedRouteAudits(routeId: number): angular.IPromise<IPlannedRouteAudit[]> {
        return this
            .$http({
                url: `/api/tms/plannedrouteaudit/${routeId}`,
                method: "GET"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IPlannedRouteAudit[]>) => {
                return response.data;
            });
    }
}
